// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","593":"fail"}[chunkId] + "." + {"443":"2bd35499","593":"3d982b4b"}[chunkId] + ".css";
};